import { render, staticRenderFns } from "./MyAppointments.vue?vue&type=template&id=0e0f7fd6&scoped=true&"
import script from "./MyAppointments.vue?vue&type=script&lang=ts&"
export * from "./MyAppointments.vue?vue&type=script&lang=ts&"
import style0 from "./MyAppointments.vue?vue&type=style&index=0&id=0e0f7fd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0f7fd6",
  null
  
)

export default component.exports